{
  "dashboard": {
    "place": {
      "inShift": "الآن في {{clinic}} · حتى {{end}}",
      "between": "المناوبة التالية: {{clinic}} · {{start}}",
      "beforeFirst": "اليوم: {{clinic}} من {{start}}",
      "done": "انتهت مناوبة اليوم · {{clinic}}",
      "overlap": "مجدول في {{count}} عيادات في الوقت نفسه",
      "noShiftToday": "لا توجد ساعات حضور مسجلة لليوم",
      "noShiftDay": "لا توجد ساعات حضور مسجلة لهذا اليوم",
      "noShiftHint": "العيادة هي التي تسجل ساعات حضورك",
      "otherDay": "{{weekday}}: {{clinic}} {{hours}}",
      "more": "و{{count}} أخرى",
      "aria": "مكان عملك حسب جدول الحضور"
    },
    "stats": {
      "total": "موعد",
      "waiting": "بالانتظار",
      "completed": "تمت",
      "cancelled": "ملغى",
      "aria": "{{total}} موعد، {{waiting}} بالانتظار، {{completed}} تمت معاينتهم، {{cancelled}} ملغى",
      "share": "الحصة: {{amount}}",
      "shareNoFigure": "الحصة"
    },
    "week": {
      "title": "اختر يومًا",
      "thisWeek": "هذا الأسبوع",
      "nextWeek": "الأسبوع القادم",
      "prevWeek": "الأسبوع الماضي",
      "range": "{{from}} – {{to}}",
      "fullCalendar": "التقويم الكامل",
      "backToWeek": "العودة إلى الأسبوع",
      "countAria": "{{count}} مواعيد"
    },
    "clinic": {
      "auto": "تلقائي — حسب جدول الحضور",
      "autoSub": "العيادة التي يحددها جدولك لهذا اليوم",
      "autoBadge": "تلقائي"
    },
    "book": {
      "open": "موعد جديد",
      "title": "حجز موعد",
      "clinic": "العيادة",
      "patient": "المريض",
      "searchLabel": "البحث عن مريض",
      "searchPlaceholder": "الاسم أو رقم الهاتف أو الرقم الوطني",
      "searchHint": "أدخل حرفين على الأقل.",
      "noMatch": "لا يوجد مريض مطابق في قائمتك.",
      "truncated": "تُعرض أول {{count}} نتيجة فقط؛ ضيّق البحث.",
      "newPatient": "مريض جديد",
      "pickExisting": "اختيار من المرضى",
      "change": "تغيير",
      "name": "الاسم الكامل",
      "phone": "رقم الجوال",
      "nationalId": "الرقم الوطني (اختياري)",
      "when": "التاريخ والوقت",
      "duration": "مدة الموعد",
      "minutes": "{{count}} دقيقة",
      "note": "ملاحظة (اختياري)",
      "submit": "حجز الموعد",
      "submitRequest": "إرسال لموافقة العيادة",
      "needsApprovalTitle": "بحاجة إلى موافقة العيادة",
      "needsApproval": "المواعيد التي تحجزها في هذه العيادة لا تصبح نهائية إلا بعد تأكيد الاستقبال، وتبقى حتى ذلك الحين «بانتظار تأكيد العيادة».",
      "booked": "تم حجز الموعد.",
      "requested": "أُرسل الموعد إلى العيادة للموافقة.",
      "loadFailed": "تعذّر تحميل قائمة العيادات.",
      "noClinic": "لا يمكنك حجز مواعيد في أي عيادة حاليًا.",
      "searchFailed": "تعذّر البحث عن المريض.",
      "modeFirstDay": "أول موعد في هذا اليوم",
      "modeFirstToday": "أول موعد اليوم",
      "modeManual": "اختيار الوقت",
      "showTimeOptions": "تغيير اليوم أو طريقة اختيار الوقت",
      "hideTimeOptions": "إخفاء خيارات الوقت",
      "noneLeftToday": "لم تعد هناك مواعيد شاغرة اليوم.",
      "finding": "جارٍ إيجاد أقرب موعد شاغر…",
      "bookThisOne": "احجزه",
      "firstFree": "أول موعد شاغر",
      "exactAtBooking": "يتحدَّد الوقت بدقة عند الحجز.",
      "firstSlotFailed": "تعذّر إيجاد أقرب موعد شاغر. يمكنك اختيار الوقت بنفسك.",
      "lessOptions": "إخفاء الخيارات الإضافية",
      "typeInPerson": "حضوري",
      "typeOnline": "عن بُعد",
      "submitFirst": "حجز أول موعد",
      "walkIn": "خارج الدور الآن",
      "walkInOff": "المريض حاضر الآن؛ يُضاف إلى دور اليوم دون تحديد وقت.",
      "walkInOn": "يُسجَّل دون وقت ويُضاف المريض الآن إلى دور اليوم.",
      "walkInOnShort": "دون وقت؛ يُضاف إلى دور اليوم.",
      "walkInLead": "لا توجد مواعيد شاغرة اليوم؛ أضف المريض الآن إلى دور اليوم دون وقت.",
      "walkInLeadShort": "دون وقت، إلى دور اليوم.",
      "walkInNoGrant": "في هذه العيادة تنتظر حجوزاتك تأكيد الاستقبال؛ المريض الحاضر يسجّله استقبال العيادة.",
      "walkInNoGrantShort": "في هذه العيادة الاستقبال فقط يسجّل خارج الدور.",
      "alreadyOpen": {
        "scheduled": "لهذا المريض موعد آخر اليوم لم يحضر بعد.",
        "arrived": "هذا المريض في دور اليوم الآن — هل يلزم موعد ثانٍ؟",
        "in_visit": "هذا المريض في زيارة الآن — هل يلزم موعد ثانٍ؟"
      },
      "submitWalkIn": "تسجيل وإضافة إلى الدور",
      "walkInBooked": "تمت إضافة المريض إلى دور اليوم.",
      "mode": "طريقة اختيار الوقت",
      "day": "اليوم",
      "visitType": "نوع الزيارة",
      "moreOptions": "خيارات إضافية (نوع الزيارة، المدة، الملاحظة)",
      "noneThisDay": "لا يوجد لديك موعد شاغر في هذا اليوم.",
      "nextIs": "أقرب موعد شاغر لديك:",
      "noneIn30Days": "لم يُعثر على موعد شاغر في الثلاثين يومًا القادمة أيضًا.",
      "slotAt": "{{date}}، الساعة {{time}}",
      "errors": {
        "clinic": "اختر العيادة.",
        "patient": "اختر المريض.",
        "name": "أدخل اسم المريض.",
        "phone": "رقم الجوال غير صالح.",
        "nationalId": "الرقم الوطني غير صالح.",
        "when": "أدخل تاريخ الموعد ووقته.",
        "past": "هذا الوقت قد مضى.",
        "noSlot": "لا يوجد موعد شاغر في هذا اليوم؛ اختر يومًا آخر أو أدخل الوقت يدويًا."
      }
    },
    "withdraw": {
      "action": "إلغاء الطلب",
      "title": "إلغاء طلب الموعد",
      "message": "هل تريد إلغاء طلب موعد {{name}}؟ سيُحذف من قائمة العيادة.",
      "confirm": "إلغاء الطلب",
      "keep": "تراجع",
      "failed": "تعذّر إلغاء الطلب."
    },
    "reschedule": {
      "action": "تغيير الوقت",
      "title": "تغيير وقت الموعد",
      "current": "الوقت الحالي: {{when}}",
      "newTime": "الوقت الجديد",
      "hint": "يُنقل الموعد ولا يُلغى ثم يُحجز من جديد، فتبقى فاتورته ودفعته كما هي.",
      "submit": "حفظ الوقت الجديد",
      "moved": "نُقل الموعد إلى {{when}}."
    }
  },
  "nav": {
    "mobile": {
      "more": "المزيد",
      "moreTitle": "المزيد",
      "account": "الحساب",
      "sections": "الأقسام",
      "balance": "رصيد {{coin}}"
    }
  }
}
